import React from "react";

import julia from "../assets/images/Julia.jpg";
import victoria from "../assets/images/Victoria.jpg";
import victoriaS from "../assets/images/VictoriaS.jpeg";

function Staff() {
  const teamMembers = [
    {
      name: "Julia",
      role: "Auktoriserad Hudterapeut",
      subtitle: "Ägare av Salong Milepa & Cidesco-diplomerad",
      bio: "Jag heter Julia och är grundare samt ägare av Salong Milepa. Min vision har alltid varit att skapa en plats där människor kan känna sig trygga, omhändertagna och lämna salongen med ny energi och välbefinnande. Med många års erfarenhet inom skönhet och service brinner jag för att bygga en salong där professionell kompetens möter ett varmt och personligt bemötande. Det betyder mycket för mig att få välkomna dig till vår salong och vårt team.",
      image: julia
    },
    {
      name: "Victoria",
      role: "Auktoriserad Hudterapeut",
      subtitle: "Cidesco-diplomerad",
      bio: "Jag heter Victoria och är SHR- och CIDESCO-examinerad hudterapeut med över 15 års erfarenhet. Sedan åtta år arbetar jag på Salong Milepa med mitt största intresse – hudvård. Mitt mål är att hjälpa kunder uppnå frisk och balanserad hud. Jag brinner för kosmetisk kemi och förstår hur ingredienser påverkar huden. Utöver ansiktsbehandlingar är jag expert på vaxning, epilering, diatermi och plasma pen.",
      image: victoria
    },
    {
      name: "Victoria S.",
      role: "Certifierad Massös",
      subtitle: "Massös, PT & Kostrådgivare",
      bio: "Jag heter Victoria och är certifierad massör, personlig tränare och kostrådgivare med lång erfarenhet inom hälsa och välmående. Mitt mål är att hjälpa dig att må bättre genom klassisk svensk massage, individanpassad träning och rådgivning kring kost – för en starkare, friskare och mer balanserad vardag.",
      image: victoriaS
    }
  ];

  const values = [
    {
      title: "Certifierade Experter",
      description: "Alla terapeuter har professionella certifieringar och kontinuerlig utbildning"
    },
    {
      title: "Passionerad Omsorg",
      description: "Dedikerade till att ge personlig, medkännande service"
    },
    {
      title: "År av Erfarenhet",
      description: "Kombinerad expertis inom skönhet och hälsa"
    }
  ];

  return (
    <div className="bg-white">
      {/* Hero */}
      <section
        className="py-32 px-6 text-center"
        style={{ background: 'linear-gradient(135deg, rgba(98, 195, 214, 0.1) 0%, rgba(211, 154, 84, 0.1) 100%)' }}
      >
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-light mb-6 text-gray-800">
            Möt Vårt <span className="font-semibold" style={{ color: 'var(--primary)' }}>Team</span>
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Högutbildade proffs dedikerade till din hälsoresa
          </p>
        </div>
      </section>

      {/* Team Members */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
              >
                <div className="relative h-96 overflow-hidden">
                  <img
                    src={member.image}
                    alt={`${member.name} - ${member.role} vid Salong Milepa`}
                    className="w-full h-full object-cover object-top"
                    style={{ objectPosition: 'center 20%' }}
                    loading="lazy" // ← Add this
                  />
                  <div
                    className="absolute bottom-0 left-0 right-0 p-4 text-white"
                    style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)' }}
                  >
                    <h3 className="text-2xl font-semibold">{member.name}</h3>
                    <p className="text-sm font-semibold opacity-90">{member.role}</p>
                    <p className="text-sm opacity-90">{member.subtitle}</p>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-12">
            {values.map((value, index) => (
              <div
                key={index}
                className="text-center"
              >
                <h3 className="text-xl font-semibold mb-3 text-gray-800">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-light mb-6 text-gray-800">
            Boka med en <span className="font-semibold" style={{ color: 'var(--primary)' }}>Specialist</span>
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Välj din föredragna terapeut när du bokar din tid
          </p>
          <a href="https://www.bokadirekt.se/places/salong-milepa-13263" target="_blank" rel="noopener noreferrer">
            <button
              className="px-8 py-4 rounded-full text-lg font-semibold text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
              style={{ backgroundColor: '#458c7d' }}
            >
              Boka Din Session
            </button>
          </a>
        </div>
      </section>
    </div>
  );
}

export default React.memo(Staff); 